import { cloneDeep } from "lodash-es";

export class ArrayUtils {
    static flatByKey<T>(source: any[], field: string): T {
        const flattened: any[] = [];
        for (const item of source) {
            const innerArr = item[field] ?? [];
            flattened.push(...innerArr);
        }
        return flattened as unknown as T;
    }

    static uniqueByKey<T>(source: T[], key: string): T[] {
        const uniques: T[] = [];
        for (const item of source) {
            const exists = uniques.map((el) => el[key]).includes(item[key]);
            if (!exists) {
                uniques.push(item);
            }
        }
        return uniques;
    }

    static flat<T>(source: T[][]): T[] {
        const flattened: T[] = [];
        for (const arr of source) {
            const inmutableArr = arr.map((item) => cloneDeep(item));
            flattened.push(...inmutableArr);
        }
        return flattened;
    }

    static removeByIndex<T>(source: T[], index: number): T[] {
        const newArray: T[] = [];
        for (let i = 0; i < source.length; i += 1) {
            if (index === i) {
                continue;
            }
            newArray.push(source[i]);
        }
        return newArray;
    }
}
